module.exports = __webpack_public_path__ + "img/mb-rightArrow.54353517.svg";